import React from 'react';
import PropTypes from 'prop-types';
import MyContentListItem from './MyContentListItem';
import NoResultsMessage from '../Global/Messages/NoResultsMessage';
import ContentList from '../Global/Lists/ContentList';
import SectionHeading from '../Global/Typography/SectionHeading';

const MyContentList = ({ myContent, moreResults, loading, ...rest }) => {
  let myContentList;
  if (myContent.length > 0) {
    myContentList = (
      <ContentList moreResults={moreResults} noPadding>
        {myContent.map(content =>
          <MyContentListItem key={content.id} content={content} {...rest} />,
        )}
      </ContentList>
    );
  } else {
    myContentList = (
      <NoResultsMessage
        title="You haven’t created any content yet."
        text="When you create content it will be listed here."
        loading={loading}
        border
      />
    );
  }

  return (
    <div className="my-content-list">
      <SectionHeading
        title="Your Content"
        subtitle="Content you create is listed here."
      />
      {myContentList}
    </div>
  );
};

MyContentList.propTypes = {
  myContent: PropTypes.array.isRequired,
  moreResults: PropTypes.bool,
  loading: PropTypes.bool,
};

export default MyContentList;



// WEBPACK FOOTER //
// ./library/app/components/Create/MyContentList.js